/**
 * The project you last opened, when it is in the workspace you are in, or
 * null. `/me/home-state` answers "last opened" across every workspace you
 * belong to, so taken alone it sent someone working in one workspace to
 * another workspace's project - with the breadcrumb still naming the
 * workspace they were in.
 */
export function lastProjectInWorkspace(
  lastProjectId: string | null | undefined,
  workspaceProjects: ReadonlyArray<{ id: string }>,
): string | null {
  return lastProjectId && workspaceProjects.some((project) => project.id === lastProjectId) ? lastProjectId : null;
}

/**
 * Where the sidebar's "Set up the widget" link goes: the project you last
 * opened in this workspace, else this workspace's first project, or null when
 * it has none. The link only opens that project's settings, where the name is
 * on screen and setting up is a further click; the Home page's quick setup
 * switches a widget on as it opens, so it uses lastProjectInWorkspace alone.
 */
export function widgetSetupProjectId(
  lastProjectId: string | null | undefined,
  workspaceProjects: ReadonlyArray<{ id: string }>,
): string | null {
  return lastProjectInWorkspace(lastProjectId, workspaceProjects) ?? workspaceProjects[0]?.id ?? null;
}
